__turbopack_context__.v({
  "armed": "p9_PPG_armed",
  "caption": "p9_PPG_caption",
  "captionNote": "p9_PPG_captionNote",
  "captionTitle": "p9_PPG_captionTitle",
  "closerSmall": "p9_PPG_closerSmall",
  "closerWide": "p9_PPG_closerWide",
  "duoCompact": "p9_PPG_duoCompact",
  "duoWide": "p9_PPG_duoWide",
  "full": "p9_PPG_full",
  "gallery": "p9_PPG_gallery",
  "header": "p9_PPG_header",
  "image": "p9_PPG_image",
  "item": "p9_PPG_item",
  "leadWide": "p9_PPG_leadWide",
  "page": "p9_PPG_page",
  "pairLarge": "p9_PPG_pairLarge",
  "pairSmall": "p9_PPG_pairSmall",
  "panelEnd": "p9_PPG_panelEnd",
  "panelMid": "p9_PPG_panelMid",
  "panelStart": "p9_PPG_panelStart",
  "plate": "p9_PPG_plate",
  "plateSquareTop": "p9_PPG_plateSquareTop",
  "sheetEnd": "p9_PPG_sheetEnd",
  "sheetStart": "p9_PPG_sheetStart",
  "shown": "p9_PPG_shown",
  "trailTall": "p9_PPG_trailTall",
  "trioEnd": "p9_PPG_trioEnd",
  "trioMid": "p9_PPG_trioMid",
  "trioStart": "p9_PPG_trioStart",
});
